import React from "react";
import { etiquetaConceptosPlameJatsa, etiquetaEstadoJatsa } from "../utils/jatsaIngestaVisible";

export const JatsaConexionBadge = () => (
  <span
    className="inline-flex items-center px-3 py-1 text-xs font-semibold rounded-full bg-indigo-50 text-indigo-800 border border-indigo-200"
    title="Al cerrar se envía a Jatsa. Al reabrir se retira."
  >
    Conectado al módulo Jatsa
  </span>
);

const JatsaIngestaEstado = ({
  estado,
  error,
  enviando,
  onReenviar,
  conceptosEstado,
  conceptosError,
  consultando,
  aplicando,
  revirtiendo,
  onConsultar,
  onAplicar,
  onRevertir,
  onVerDatosApi,
  puedeRevertir = false,
  hrefJatsa = "",
  abriendoJatsa = false,
  onAbrirJatsa,
}) => {
  const etiqueta = etiquetaEstadoJatsa(estado);
  const esError = String(estado || "").toLowerCase() === "error";
  const etiquetaConceptos = etiquetaConceptosPlameJatsa(conceptosEstado);
  const conceptosListos = String(conceptosEstado || "").toLowerCase() === "disponible";
  const conceptosAplicados = String(conceptosEstado || "").toLowerCase() === "aplicado";
  const conceptosFallaron = String(conceptosEstado || "").toLowerCase() === "error";
  const ocupado = enviando || consultando || aplicando || revirtiendo || abriendoJatsa;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span
        className={`inline-flex items-center px-3 py-1 text-sm font-semibold rounded-full border ${
          esError
            ? "bg-red-50 text-red-800 border-red-200"
            : "bg-slate-50 text-slate-800 border-slate-200"
        }`}
        title={esError && error ? error : etiqueta}
      >
        {etiqueta}
      </span>
      {hrefJatsa || onAbrirJatsa ? (
        <button
          type="button"
          onClick={onAbrirJatsa}
          disabled={ocupado || abriendoJatsa || !onAbrirJatsa}
          className="px-3 py-1 bg-white text-indigo-800 border border-indigo-300 rounded-lg hover:bg-indigo-50 transition-colors text-sm font-medium disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
          title="Abre la ficha de este periodo en Jatsa con tu sesión"
        >
          {abriendoJatsa ? "Abriendo Jatsa..." : "Abrir Jatsa"}
        </button>
      ) : null}
      <button
        type="button"
        onClick={onReenviar}
        disabled={ocupado}
        className="px-3 py-1 bg-slate-700 text-white rounded-lg hover:bg-slate-800 transition-colors text-sm font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
      >
        {enviando ? "Reenviando..." : "Reenviar a Jatsa"}
      </button>
      <span
        className={`inline-flex items-center px-3 py-1 text-sm font-semibold rounded-full border ${
          conceptosFallaron
            ? "bg-red-50 text-red-800 border-red-200"
            : conceptosListos
              ? "bg-amber-50 text-amber-800 border-amber-200"
              : conceptosAplicados
                ? "bg-teal-50 text-teal-800 border-teal-200"
                : "bg-slate-50 text-slate-800 border-slate-200"
        }`}
        title={conceptosError || etiquetaConceptos}
      >
        {etiquetaConceptos}
      </span>
      <button
        type="button"
        onClick={onConsultar}
        disabled={ocupado}
        className="px-3 py-1 bg-white text-slate-700 border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors text-sm font-medium disabled:bg-gray-100 disabled:cursor-not-allowed"
      >
        {consultando ? "Consultando..." : "Consultar Jatsa"}
      </button>
      <button
        type="button"
        onClick={onAplicar}
        disabled={ocupado}
        className="px-3 py-1 bg-indigo-700 text-white rounded-lg hover:bg-indigo-800 transition-colors text-sm font-medium disabled:bg-gray-400 disabled:cursor-not-allowed"
      >
        {aplicando ? "Aplicando y recerrando..." : "Traer conceptos a PLAME"}
      </button>
      <button
        type="button"
        onClick={onVerDatosApi}
        disabled={ocupado || !onVerDatosApi}
        className="px-3 py-1 bg-white text-indigo-800 border border-indigo-200 rounded-lg hover:bg-indigo-50 transition-colors text-sm font-medium disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
        title="Consulta Jatsa y muestra el JSON que llega del satélite"
      >
        Ver datos de la API
      </button>
      <button
        type="button"
        onClick={onRevertir}
        disabled={ocupado || !puedeRevertir}
        className="px-3 py-1 bg-white text-red-700 border border-red-300 rounded-lg hover:bg-red-50 transition-colors text-sm font-medium disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
        title="Retira la planilla de Jatsa y quita los conceptos 0909/0902/0917 que trajo"
      >
        {revirtiendo ? "Revirtiendo..." : "Revertir sincronización"}
      </button>
    </div>
  );
};

export default JatsaIngestaEstado;
